import { render } from "./SubscriptionPage.vue?vue&type=template&id=72582512&scoped=true"
import script from "./SubscriptionPage.vue?vue&type=script&lang=js"
export * from "./SubscriptionPage.vue?vue&type=script&lang=js"

import "./SubscriptionPage.vue?vue&type=style&index=0&id=72582512&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72582512"]])

export default __exports__